/**
 * Service: settlementsApi
 */
angular.module('acme.common.service.settlementsApi', [])
.service('SettlementsApiService', [ '$http',  function($http) {

    return {

        init: function(endpoint) {
            this.service = endpoint + '/settlements';
            this.transactions.service = this.service;
            return this;
        },

        service: '',

        /**
         * Gets the headers for the settlements
         *
         * @returns {*}
         */
        list: function(page) {
            var query = '?pageNumber=1';

            if (page) {
                query = '?pageNumber=' + page;
            }

            console.log('SettlementsApiService::list', query);
            return $http({
                method: 'get',
                url: this.service + '/headers' + query
            });
        },

        /**
         * Gets an individual settlement
         *
         * @returns {*}
         */
        get: function(id) {
            console.log('SettlementsApiService::get');
            return $http({
                method: 'get',
                url: this.service + '/' + id
            });
        },

        /**
         * Gets an individual settlement
         *
         * @returns {*}
         */
        create: function(date) {
            console.log('SettlementsApiService::create');
            return $http({
                method: 'post',
                url: this.service + "?settlementEndDate=" + date
            });
        },

        transactions: {

            service: '',

            list: function(id, page) {
                var query = '?pageNumber=1';

                if (page) {
                    query = '?pageNumber=' + page;
                }

                console.log('SettlementsApiService::transactions.list', query);
                return $http({
                    method: 'get',
                    url: this.service + '/' + id + '/transactions' + query
                });
            },

            get: function(id, transId) {
                console.log('SettlementsApiService::transactions.get');
                return $http({
                    method: 'get',
                    url: this.service + '/' + transId + '/transactions/' + id
                });
            }

        }
    };

}]);